<template>
  <div class="home">
    <!-- Header -->
    <div class="container p-0">
      <img src="@/assets/img/header-advisor.png" alt="header" width="100%" />
    </div>
    <!-- Header -->

    <!-- Body -->
    <div class="container">
      <div class="row bg_ffffff">
        <div class="col-12 col-sm-12 padding_30 padding_top_0">
          <div class="csfont_Signika_Lite color_6d6e71 text-left font-size-16">
            <form @submit.prevent="Submit" v-if="!viewNone">
              <div class="row px-3">
                <div class="col-12 col-sm-12 mt-4">
                  <p>เรียน อาจารย์ที่ปรึกษา</p>
                  <p class="mb-0">
                    &emsp;&emsp;
                    เพื่อโปรดกรุณาสอบถามข้อมูลเกี่ยวกับนักศึกษาผู้ขอรับทุน
                    ตามข้อความข้างล่างนี้
                    หรือตามที่ท่านเห็นควรซึ่งคณะกรรมการพิจารณาทุนการศึกษาจะได้นำมาใช้ประกอบการพิจารณาการขอทุนของนักศึกษา
                    ต่อไป
                  </p>
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-12 mt-1">
                  <p class="mb-0">
                    <span class="text-bold"> ชื่อผู้ขอรับทุนการศึกษา </span>
                  </p>
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-4 col-md-3">
                  <span class="pl-2"> คำนำหน้า: </span>
                  <select
                    style="padding: 4px; margin-left: 5px"
                    class="w-100 ml-1"
                    :class="titleSelect == true ? 'text-secondary' : ''"
                    required
                    @change="TitleChange"
                    v-model="AdvisorCertificate.title"
                  >
                    <option selected disabled :value="null">
                      --- คำนำหน้า ---
                    </option>
                    <option value="นาย">นาย</option>
                    <option value="นางสาว">นางสาว</option>
                  </select>
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-8 col-md-9">
                  <span class="pl-2">ชื่อ-สกุล:</span>
                  <input
                    type="text"
                    class="ml-1 w-100"
                    required
                    v-model="AdvisorCertificate.Name"
                    placeholder="---"
                    style="padding-left: 10px; padding: 2.5px"
                  />
                </div>
                 <!-- *************************************************** -->
                <div class="col-12 col-sm-6 col-md-6">
                  <span class="pl-2">อีเมล:</span>
                  <input
                    type="email"
                    class="ml-1 w-100"
                    required
                    v-model="AdvisorCertificate.Email"
                    placeholder="---"
                    style="padding-left: 10px; padding: 2.5px"
                  />
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-6 col-md-6">
                  <span class="pl-2">เลขทะเบียน:</span>
                  <input
                    type="text"
                    class="ml-1 w-100"
                    required
                    v-model="AdvisorCertificate.Number"
                    placeholder="---"
                    style="padding-left: 10px; padding: 2.5px"
                  />
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-6 col-md-6">
                  <span class="pl-2">คณะ:</span>
                  <input
                    type="text"
                    class="ml-1 w-100"
                    required
                    v-model="AdvisorCertificate.Faculty"
                    placeholder="---"
                    style="padding-left: 10px; padding: 2.5px"
                  />
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-6 col-md-6">
                  <span class="pl-2">สาขาวิชา:</span>
                  <input
                    type="text"
                    class="ml-1 w-100"
                    required
                    v-model="AdvisorCertificate.Major"
                    placeholder="---"
                    style="padding-left: 10px; padding: 2.5px"
                  />
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-6 col-md-6">
                  <span class="pl-2">ชั้นปีที่:</span>
                  <input
                    type="text"
                    class="ml-1 w-100"
                    required
                    v-model="AdvisorCertificate.YearClass"
                    placeholder="---"
                    style="padding-left: 10px; padding: 2.5px"
                  />
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-12 mt-4">
                  <span class="text-bold">
                    1. ฐานะทางเศรษฐกิจของผู้ขอรับทุน
                  </span>
                  <ul style="list-style: none" class="mt-1">
                    <li class="mt-2">
                      1.1 ลักษณะอาชีพของบิดามารดา หรือผู้ปกครอง
                    </li>
                    <li class="mt-2">
                      &emsp;
                      <input
                        type="text"
                        class="pl-1 w-85 mb-1"
                        placeholder="---"
                        required
                        v-model="
                          AdvisorCertificate.EconomicStatusOfTheApplicant
                            .Occupation
                        "
                        style="padding-left: 10px"
                      />
                    </li>
                    <li class="mt-2">1.2 รายได้ของบิดามารดา หรือผู้ปกครอง</li>
                    <li class="mt-2">
                      &emsp;
                      <input
                        type="text"
                        class="pl-1 w-85 mb-1"
                        placeholder="---"
                        required
                        v-model="
                          AdvisorCertificate.EconomicStatusOfTheApplicant.Income
                        "
                        style="padding-left: 10px"
                      />
                    </li>
                    <li class="mt-2">1.3 ความขาดแคลนของผู้รับทุน</li>
                    <li class="mt-2">
                      &emsp;
                      <input
                        type="text"
                        class="pl-1 w-85 mb-1"
                        placeholder="---"
                        required
                        v-model="
                          AdvisorCertificate.EconomicStatusOfTheApplicant
                            .Scarcity
                        "
                        style="padding-left: 10px"
                      />
                    </li>
                  </ul>
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-12 mt-3">
                  <span class="text-bold">
                    2. ความเป็นอยู่ การใช้ชีวิตประจำวันของผู้รับทุน
                  </span>
                  <ul style="list-style: none" class="mt-1">
                    <li class="mt-2">2.1 การทำงานพิเศษหารายได้ช่วยตนเอง</li>
                    <li class="mt-2">
                      &emsp;
                      <input
                        type="text"
                        class="pl-1 w-85 mb-1"
                        placeholder="---"
                        required
                        v-model="AdvisorCertificate.DailyLife.EarnExtraMoney"
                        style="padding-left: 10px"
                      />
                    </li>
                    <li class="mt-2">
                      2.2 การทำกิจกรรมในมหาวิทยาลัย / นอกมหาวิทยาลัย
                    </li>
                    <li class="mt-2">
                      &emsp;
                      <input
                        type="text"
                        class="pl-1 w-85 mb-1"
                        placeholder="---"
                        required
                        v-model="AdvisorCertificate.DailyLife.Activities"
                        style="padding-left: 10px"
                      />
                    </li>
                    <li class="mt-2">2.3 สุขภาพ</li>
                    <li class="mt-2">
                      &emsp;
                      <input
                        type="text"
                        class="pl-1 w-85 mb-1"
                        placeholder="---"
                        required
                        v-model="AdvisorCertificate.DailyLife.Health"
                        style="padding-left: 10px"
                      />
                    </li>
                    <li class="mt-2">2.4 ความประพฤติ</li>
                    <li class="mt-2">
                      &emsp;
                      <input
                        type="text"
                        class="pl-1 w-85 mb-1"
                        placeholder="---"
                        required
                        v-model="AdvisorCertificate.DailyLife.Behavior"
                        style="padding-left: 10px"
                      />
                    </li>
                  </ul>
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-12 mt-3">
                  <span class="text-bold"> 3. ด้านการเรียน </span>
                  <ul style="list-style: none" class="mt-1">
                    <li class="mt-2">3.1 ความสนใจด้านการเรียน</li>
                    <li class="mt-2">
                      &emsp;
                      <input
                        type="text"
                        class="pl-1 w-85 mb-1"
                        placeholder="---"
                        required
                        v-model="AdvisorCertificate.Education.StudySnterest"
                        style="padding-left: 10px"
                      />
                    </li>
                  </ul>
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-12 mt-3">
                  <span class="text-bold">
                    4. เหตุผลและความจำเป็น
                    ตลอดจนปัญหาของผู้ขอรับทุนในทัศนะของท่าน
                  </span>
                  <div>
                    &emsp;<textarea
                      rows="3"
                      class="pl-1 w-85 mb-1 mt-2"
                      style="padding-left: 10px"
                      placeholder="---"
                      required
                      v-model="AdvisorCertificate.ReasonAndNecessity"
                    ></textarea>
                  </div>
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-12 mt-3">
                  <span class="text-bold">
                    5. นักศึกษาผู้นี้สมควรได้รับการพิจารณาให้ได้รับทุนหรือไม่
                  </span>
                  <ul style="list-style: none" class="mt-1">
                    <li class="mt-2">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="Consideration"
                        :value="1"
                        required
                        @click="ConsiderationStatus()"
                        v-model="AdvisorCertificate.Consideration.Status"
                      />
                      <span>&ensp;สมควรได้รับทุน เนื่องจาก</span>
                    </li>
                    <li :class="AdvisorCertificate.Consideration.Status== 1? '':'d-none'">
                      &emsp;
                      <input
                        type="text"
                        class="ml-1 w-85 mb-1"
                        placeholder="---"
                        required
                        v-model="AdvisorCertificate.Consideration.Detail"
                        :disabled="AdvisorCertificate.Consideration.Status== 1? false:true"
                        style="padding-left: 10px"
                      />
                    </li>
                    <li class="mt-2">
                      <input
                        class="form-check-input"
                        type="radio"
                        required
                        name="Consideration"
                        :value="0"
                        @click="ConsiderationStatus()"
                        v-model="AdvisorCertificate.Consideration.Status"
                      />
                      <span>&ensp;ไม่สมควร เนื่องจาก</span>
                    </li>
                    <li :class="AdvisorCertificate.Consideration.Status== 0? '':'d-none'">
                      &emsp;
                      <input
                        type="text"
                        class="ml-1 w-85 mb-1"
                        placeholder="---"
                        required
                         :disabled="AdvisorCertificate.Consideration.Status== 0? false:true"
                        v-model="AdvisorCertificate.Consideration.Detail"
                        style="padding-left: 10px"
                      />
                    </li>
                  </ul>
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-8 mt-3" id="Signature">
                  <div class="row mt-2">
                    <div class="col-12 col-md-8">
                      <span> อาจารย์ที่ปรึกษา: </span>
                      <input
                        type="text"
                        class="ml-1 w-100 mb-1"
                        placeholder="---"
                        required
                        v-model="AdvisorCertificate.Signature.Name"
                        style="padding-left: 10px"
                      />
                    </div>
                     <div class="col-12 col-md-8 mt-3">
                      <span>อีเมล: </span>
                      <input
                        type="email"
                        class="ml-1 w-100 mb-1"
                        placeholder="---"
                        required
                        v-model="AdvisorCertificate.Signature.Email"
                        style="padding-left: 10px"
                      />
                    </div>
                    <div class="col-12 col-md-8  mt-3">
                      <span> โทรศัพท์: </span>
                      <input
                        type="text"
                        class="ml-1 w-100 mb-1"
                        placeholder="---"
                        required
                         v-model="AdvisorCertificate.Signature.Phone"
                        style="padding-left: 10px"
                      />
                    </div>
                    <div class="col-12 col-md-8  mt-3">
                      <span> วันที่: </span>
                      <input
                        type="date"
                        class="ml-1 w-100 mb-1"
                        placeholder="---"
                        required
                         v-model="AdvisorCertificate.Signature.Date"
                        style="padding-left: 10px"
                      />
                    </div>
                  </div>
                </div>
                <!-- *************************************************** -->
                <!-- *************************************************** -->
                <div class="col-12 col-sm-4 mt-3">
                  <div class="row">
                    <div class="col-12 mt-3">
                    <img
                    :src="FileUploadURL"
                    alt="placeholder"
                    class="img-cover"
                    />
                    </div>
                    <div class="col-12 mt-3 text-center">
                      <label
                        for="AuthorisedSignatureUpload"
                        class="custom-file-upload btn btn-app"
                      >
                        ลายเซ็น
                      </label>
                    </div>
                    <div class="col-8 col-md-8 text-truncate mt-3">
                      {{AdvisorCertificate.Signature.SignatureImageOldName}}
                    </div>
                    <input
                      id="AuthorisedSignatureUpload"
                      type="file"
                      @change="FileSignature"
                      accept="image/*"
                    />
                  </div>
                 
                </div>

                <!-- *************************************************** -->
              </div>
              <center>
                 <a
                  v-if="preview"
                  class="btn btn-app mt-3 align-center mx-1"
                  @click="EditIncome"
                >
                  <div>ย้อนกลับ</div>
                </a>
                <button type="submit" class="btn btn-app mt-3 align-center">
                  <div v-if="!display">ต่อไป</div>
                  <div class="loader" v-if="display">Loading...</div>
                </button>
              </center>
              <br />
            </form>
            <div class="row" v-else>
              <div class="col-12 col-sm-12 col-md-12 px-5 mt-4">
                <p>เรียน อาจารย์ที่ปรึกษา</p>
                <p class="mb-0 text-justify">
                  &emsp;&emsp;
                  เพื่อโปรดกรุณาสอบถามข้อมูลเกี่ยวกับนักศึกษาผู้ขอรับทุนตามข้อความข้างล่างนี้ หรือตามที่ท่านเห็นควรซึ่งคณะกรรมการพิจารณาทุนการศึกษาจะได้นำมาใช้ประกอบการพิจารณาการขอทุนของนักศึกษาต่อไป
                </p>
              </div>
              <div class="col-12 col-sm-12 col-md-12 px-5">
                <p class="my-2">
                  ชื่อผู้ขอรับทุนการศึกษา 
                  {{ AdvisorCertificate.title }} 
                  {{ AdvisorCertificate.Name }} อีเมล
                  {{ AdvisorCertificate.Email }} เลขทะเบียน
                  {{ AdvisorCertificate.Number }} 
                  คณะ{{ AdvisorCertificate.Faculty }} 
                  สาขาวิชา{{ AdvisorCertificate.Major }} ชั้นปีที่
                  {{ AdvisorCertificate.YearClass }}
                </p>
                <p>
                  <ol class="pl-2">
                    <li class="mt-2">
                      <span>ฐานะทางเศรษฐกิจของผู้ขอรับทุน</span>
                      <ul class="list-unstyled ml-2">
                        <li>
                           <span>1.1 ลักษณะอาชีพของบิดามารดา หรือผู้ปกครอง</span>
                           <br>
                          <p class="pl-2">&emsp;{{AdvisorCertificate.EconomicStatusOfTheApplicant.Occupation }}</p>
                        </li>
                        <li>
                           <span>1.2 รายได้ของบิดามารดา หรือผู้ปกครอง</span>
                           <br>
                          <p class="pl-2">&emsp;{{AdvisorCertificate.EconomicStatusOfTheApplicant.Income }}</p>
                        </li>
                        <li>
                           <span>1.3 ความขาดแคลนของผู้รับทุน</span>
                           <br>
                          <p class="pl-2">&emsp;{{AdvisorCertificate.EconomicStatusOfTheApplicant.Scarcity }}</p>
                        </li>
                      </ul>
                    </li>
                    <li class="mt-2">
                      <span>ความเป็นอยู่ การใช้ชีวิตประจำวันของผู้รับทุน</span>
                       <ul class="list-unstyled ml-2">
                        <li>
                           <span>2.1 การทำงานพิเศษหารายได้ช่วยตนเอง</span>
                           <br>
                          <p class="pl-2">&emsp;{{AdvisorCertificate.DailyLife.EarnExtraMoney }}</p>
                        </li>
                        <li>
                           <span>2.2 การทำกิจกรรมในมหาวิทยาลัย / นอกมหาวิทยาลัย</span>
                           <br>
                          <p class="pl-2">&emsp;{{AdvisorCertificate.DailyLife.Activities }}</p>
                        </li>
                        <li>
                           <span>2.3 สุขภาพ</span>
                           <br>
                          <p class="pl-2">&emsp;{{AdvisorCertificate.DailyLife.Health }}</p>
                        </li>
                        <li>
                          <span>2.4 ความประพฤติ</span>
                           <br>
                          <p class="pl-2">&emsp;{{AdvisorCertificate.DailyLife.Behavior }}</p>
                        </li>
                      </ul>
                    </li>
                    <li class="mt-2">
                      <span>ด้านการเรียน</span>
                       <ul class="list-unstyled ml-2">
                        <li>
                          <span>3.1 ความสนใจด้านการเรียน</span>
                          <br>
                          <p class="pl-2">&emsp;{{AdvisorCertificate.Education.StudySnterest }}</p>
                        </li>
                      </ul>
                    </li>
                    <li class="mt-2">
                      <span>เหตุผลและความจำเป็น ตลอดจนปัญหาของผู้ขอรับทุนในทัศนะของท่าน</span><br>
                      <p class="pl-2">&emsp;{{AdvisorCertificate.ReasonAndNecessity }}</p>
                    </li>
                    <li class="mt-2">
                       <span>นักศึกษาผู้นี้สมควรได้รับการพิจารณาให้ได้รับทุนหรือไม่</span>
                       <ul class="list-unstyled ml-2">
                          <li :class="AdvisorCertificate.Consideration.Status == 1? '':'d-none'">
                            <span>สมควรได้รับทุน เนื่องจาก</span>
                             <span>&ensp;{{AdvisorCertificate.Consideration.Detail }}</span>
                            </li>
                          <li :class="AdvisorCertificate.Consideration.Status == 0? '':'d-none'">
                             <span>ไม่สมควร เนื่องจาก</span>
                              <span>&ensp;{{AdvisorCertificate.Consideration.Detail }}</span>
                            </li>
                        </ul>
                    </li>
                  </ol>
                </p>
              </div>
              <div class="col-12 col-sm-6 col-md-7 mt-2 text-dark">
                </div>
                <div class="col-12 col-sm-6 col-md-5 mt-2 text-dark">
                  <p align="right" class="mb-0">ลงชื่อ: <img
                        :src="FileUploadURL"
                        alt="placeholder"
                        class="img-cover w-50"
                      />
                  </p>
                  <p align="right" class="mb-0">( {{AdvisorCertificate.Signature.Name}} )&ensp;</p>
                  <p align="right" class="mb-0">อีเมล {{AdvisorCertificate.Signature.Email}}&ensp;</p>
                  <p align="right" class="mb-0">โทรศัพท์ {{AdvisorCertificate.Signature.Phone}}&ensp;</p>
                  <p align="right" class="mb-0">วันที่ {{AdvisorCertificate.Signature.Date}}&ensp;</p>
                </div>
              <div class="col-12 col-sm-12 col-md-12 text-center">
                <button
                  v-if="edit"
                  :disabled="display"
                  class="btn btn-app mt-5 align-center mx-1"
                  @click="editeForm()"
                >
                  <div>&ensp;แก้ไข&ensp;</div>
                </button>
                <a
                  v-if="submit"
                  class="btn btn-app mt-5 align-center mx-1 "
                  @click="submitForm()"
                >
                  <div v-if="!display">ต่อไป</div>
                  <div class="loader m-tb-4" v-if="display">Loading...</div>
                </a>
             </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Body -->
    
    <!-- Footer -->
    <div class="container p-0">
      <img src="@/assets/img/footer.png" alt="header" width="100%" />
    </div>
    <!-- Footer -->
  </div>
</template>

<script>
// CSS
import "@/assets/bootstrap/bootstrap.min.css";
import "@/assets/bootstrap/animate.css";
import "@/assets/bootstrap/fontface.css";
import "@/assets/css/font.css";
import "@/assets/bootstrap/custom.css";
import "@/assets/css/spacing.css";
import "vue-multiselect/dist/vue-multiselect.min.css";

// Component
import { store } from "@/store";
import axios from "axios";

export default {
  name: "Home",
  store,
  data() {
    return {
      display: false,
      RandomID: null,
      preview: true,
      edit: false,
      submit: false,
      viewNone: false,
      AdvisorCertificate: {
        title: null,
        Name: "",
        Email: "",
        Number: "",
        Faculty: "",
        Major: "",
        YearClass: "",
        EconomicStatusOfTheApplicant: {
          Occupation: "",
          Income: "",
          Scarcity: "",
        },
        DailyLife: {
          EarnExtraMoney: "",
          Activities: "",
          Health: "",
          Behavior: "",
        },
        Education: {
          StudySnterest: "",
        },
        ReasonAndNecessity: "",
        Consideration: {
          Status: "",
          Detail: "",
        },
        Signature: {
          SignatureImage: "",
          SignatureImageOldName: "",
          Name: "",
          Date: "",
          Email: "",
          Phone: "",
        },
      },
      FileUpload: null,
      FileUploadURL: "https://via.placeholder.com/200?text=CPF",
      titleSelect: true,
      // BaseURLData: "http://localhost:8085/form/scholarship/",
      // BaseAPIData: "http://localhost:8083/",

      BaseURLData: "https://tica.or.th/uploads/form/scholarship-cpf/",
      BaseAPIData:
        "https://tica.or.th/uploads/form/scholarship-cpf/images/save/",
    };
  },
  async created() {
    sessionStorage.setItem("IncomeEdit", false);
    this.RandomID = await sessionStorage.getItem("UID");
  },
  mounted() {
    if (
      sessionStorage.getItem("AdvisorEdit") == "true" &&
      sessionStorage.getItem("dataI3") != null
    ) {
      const editeData = sessionStorage.getItem("dataI3");
      this.AdvisorCertificate = JSON.parse(editeData);
      this.FileUploadURL = this.AdvisorCertificate.Signature.SignatureImage;
    } 
    else {
      // this.AdvisorCertificate = {
      //   title: "นาย",
      //   Email: "a@mail.com",
      //   Name: "สมพง ทรงสิทธ์",
      //   Number: "65030100",
      //   Faculty: "วิศวกรรมศาสตร์",
      //   Major: "วิศวกรรมเครื่องกล",
      //   YearClass: "2",
      //   EconomicStatusOfTheApplicant: {
      //     Occupation:
      //       "ธุรกิจส่วนตัว",
      //     Income:
      //       "260000/ปี",
      //     Scarcity:
      //       "ธุระกิจขาดทุนต่อเนื่อง",
      //   },
      //   DailyLife: {
      //     EarnExtraMoney:
      //       "พนักงานร้านอาหาร",
      //     Activities:
      //       "ชมรม, ค่ายอาสา",
      //     Health:
      //       "โรคภูมิแพ้",
      //     Behavior:
      //       "ดีเยี่ยม",
      //   },
      //   Education: {
      //     StudySnterest:
      //       "สนใจในด้าน การผลิตสื่อโฆษณา",
      //   },
      //   ReasonAndNecessity:
      //     "ครอบครัวมีปัญหาด้านการเงิน",
      //   Consideration: {
      //     Status: 0,
      //     Detail:
      //       "เป็นบุคคลที่เหมาะสม",
      //   },
      //   Signature: {
      //     SignatureImage: "",
      //     SignatureImageOldName: "",
      //     Name: "ประสงค์ จงกระเบน",
      //     Email: "e@mail.com",
      //     Date: null,
      //     Phone: "020-002-0002",
      //   },

      // };
    }
  },
  methods: {
    Submit() {
      if (this.FileUpload == null) {
        alert("กรุณาอัปโหลด ลายเซ็น");
        document.getElementById("Signature").scrollIntoView();
      } else {
        this.previewForm();
      }
    },
    TitleChange() {
      this.AdvisorCertificate.title == null
        ? (this.titleSelect = true)
        : (this.titleSelect = false);
    },
    ConsiderationStatus() {
      this.AdvisorCertificate.Consideration.Detail = "";
    },
    FileSignature(evt) {
      evt.preventDefault();
      this.FileUpload = evt.target.files[0];
      this.FileUploadURL = URL.createObjectURL(this.FileUpload);
      this.AdvisorCertificate.Signature.SignatureImageOldName =
        evt.target.files[0].name;
    },
    previewForm() {
      this.preview = !this.preview;
      this.edit = !this.edit;
      this.submit = !this.submit;
      this.viewNone = !this.viewNone;
    },
    EditIncome() {
      this.$emit("AdvisorFuncBack");
    },
    editeForm() {
      this.preview = !this.preview;
      this.edit = !this.edit;
      this.submit = !this.submit;
      this.viewNone = !this.viewNone;
    },
    async submitForm() {
      if (this.display == false) {
        this.display = !this.display;
      }
      // Upload file
      if (
        sessionStorage.getItem("AdvisorEdit") == "true" &&
        sessionStorage.getItem("dataI2") != null
      ) {
        if (this.FileUpload != null) {
          this.AdvisorCertificate.Signature.SignatureImage =
            await this.UploadFile(this.FileUpload,
          "signature",
          "advisorSignature");
        }
      } else {
        this.AdvisorCertificate.Signature.SignatureImage =
          await this.UploadFile(this.FileUpload,
          "signature",
          "advisorSignature");
      }
      // set session
      await this.SetSession();
      // call func paren page
      await this.$emit("AdvisorFunc");
      sessionStorage.setItem("AdvisorEdit", false);
    },
    async UploadFile(fileData, folder, Name) {
      var FileName = "";
      const UID = this.RandomID;
      const BaseURLData = this.BaseURLData;
      const BaseAPIData = this.BaseAPIData;
      const data = new FormData();
      data.append("fileUpload", fileData);
      data.append("fileName", Name);
      data.append("target", UID);
      data.append("subtarget", folder);

      const url =`${BaseAPIData}uploadFile.php`;
      const header = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      await axios.post(url, data, header).then(function (response) {
        FileName = `${BaseURLData}images/save/assets/img/${UID}/${folder}/${response.data.response}.${response.data.type}`;
      });
      return FileName;
    },
    async SetSession() {
      await sessionStorage.setItem(
        "dataI3",
        JSON.stringify(this.AdvisorCertificate)
      );
    },
  },
};
</script>

<style scoped>
.w-100 {
  width: 100% !important;
}
.bg_dark_blue {
  background-color: #102f50 !important;
}
.text-secondary {
  border-top: 1px solid #bfc6cc !important;
}
.catgory-input {
  position: absolute !important;
  right: 0 !important;
  padding-right: 5% !important;
}
.home {
  background-color: #3c3c3b !important;
  font-family: Georgia, Times, serif !important;
}
input[type="file"] {
  display: none !important;
}
.custom-file-upload {
  border: 1px solid #ccc !important;
  display: inline !important;
  padding: 5px 12px !important;
  cursor: pointer !important;
  white-space: normal !important;
}

.custom-exam-upload {
  border: 1px solid #ccc !important;
  display: inline !important;
  padding: 5px 12px !important;
  cursor: pointer !important;
  white-space: normal !important;
}
.btn-app {
  color: #fff !important;
  background-color: #102f51 !important;
}
.btn-app:hover {
  color: #fff !important;
  background-color: #235a99 !important;
}
.text-truncate {
  white-space: nowrap !important;
  padding-right: 5rem !important;
  padding-left: 1rem !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.w-45 {
  width: 45%;
}
.other-btn {
  padding: 6px 25px !important;
}
</style>
<style>
.multiselect__option--highlight {
  background: #102f51 !important;
  outline: none !important;
  color: #fff !important;
}
.multiselect__option--highlight:after {
  background: #102f51 !important;
}
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #102f51;
  margin-bottom: 0;
}
.multiselect__tags {
  min-height: 25px;
  padding: 2px 40px 0 8px;
  border-color: black;
}
.multiselect__tag-icon:after {
  color: white;
}
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #102f51 !important;
}
.req {
  border-color: red !important;
}

.img-cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>